import React, { useState, useEffect } from "react";
import { X, Send, Bot, Sparkles } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSimpleResponse } from "../utils/simpleGroqService";

const SimpleChatbot = () => {
  const [inputValue, setInputValue] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [currentResponse, setCurrentResponse] = useState(null);
  const [showPromoPopup, setShowPromoPopup] = useState(false);
  const [promoShown, setPromoShown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentPage = () => {
    const path = location.pathname;
    if (path === "/") return "Home";
    if (path === "/contact") return "Contact";
    if (path === "/about") return "About";
    if (path === "/skills") return "Skills";
    if (path === "/projects") return "Projects";
    return "Portfolio";
  };

  useEffect(() => {
    if (!promoShown) {
      const timer = setTimeout(() => {
        setShowPromoPopup(true);
        setPromoShown(true);
      }, 120000);
      return () => clearTimeout(timer);
    }
  }, [promoShown]);

  const handleSendMessage = async () => {
    if (!inputValue.trim() || isTyping) return;
    const currentInput = inputValue;
    const currentPage = getCurrentPage();
    setInputValue("");
    setIsTyping(true);
    setShowPromoPopup(false);
    try {
      const contextualInput = `[User is on ${currentPage} page] ${currentInput}`;
      const aiResponse = await getSimpleResponse(contextualInput);
      setCurrentResponse({
        id: Date.now(),
        question: currentInput,
        answer: aiResponse,
        timestamp: new Date(),
        page: currentPage,
      });
    } catch (error) {
      setCurrentResponse({
        id: Date.now(),
        question: currentInput,
        answer:
          "Something went wrong. Try asking about skills, projects, or experience.",
        timestamp: new Date(),
        page: currentPage,
      });
    } finally {
      setIsTyping(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const closePanel = () => setCurrentResponse(null);
  const closePromoPopup = () => setShowPromoPopup(false);
  const handlePromoClick = () => {
    setShowPromoPopup(false);
    navigate("/mentee");
  };

  return <></>;
};

export default SimpleChatbot;
